/* eslint-disable camelcase */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import CryptoJS from 'crypto-js'
import { Link } from 'react-router-dom'
import MegaMenu from '../MegaMenu'
import { Navbar, Nav, Dropdown } from 'react-bootstrap'
import SwitchOrganizationModal from '../Modals/SwitchOrganizationModal'
import AcknowledgmentModal from '../../components/Modals/AcknowledgmentModal'
import ProviderDetailModal from '../../components/Modals/ProviderDetailModal'
import Can from '../../config/Can'
import CarePlanToSign from '../../types/CarePlanToSign'
import Organization from '../../types/Organization'
import Provider from '../../types/Provider'
import ProviderDetailToUpdate from '../../types/ProviderDetailToUpdate'
import RootState from '../../types/RootState'
import User from '../../types/User'
import { getCarePlanToSign, getCarePlanGrid } from '../../redux/actions/carePlan'
import { getDetailToUpdate } from '../../redux/actions/providerDetail'
import { addUserActivity, unauthUser, setSelectedOrganization, showOrganizationModal, setProviderList } from '../../redux/actions/authentication'
import { updateProviderAcknowledge } from '../../redux/actions/carePlan'
import { getBannerColor } from '../../utils/envVariables'
import { sortArrayOfObjects } from '../../utils/dataTools'
import LogoImage from './images/logo.png'
import './index.css'


interface Props {
  carePlanToSign: Array<CarePlanToSign>;
  organizationModal: boolean;
  providerDetailToUpdate: Array<ProviderDetailToUpdate>;
  selectedOrganization: Organization;
  updateProviderAcknowledgeState: any;
  user: User;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string) => void;
  getCarePlanToSign: (organizationId: number, eid: string, token: string) => void;
  getCarePlanGrid: (organizationId: number, eid: string, token: string) => void;
  getDetailToUpdate: (id: number, eid: string, token: string) => void;
  setProviderList: (providerList: Array<Provider>) => void;
  setSelectedOrganization: (organization: Organization) => void;
  showOrganizationModal: (organizationModal: boolean) => void;
  unauthUser: () => void;
  updateProviderAcknowledge: (data: any, token: string) => void;
}

const generateOrganizationList = (
  providers: Array<Organization>
) => {
  let organizationList: any = []

  providers.forEach((provider) => { organizationList.push({ value: provider.organization_id + '', label: provider.organization_name }) })

  return organizationList
}

class Header extends Component<Props & RouteComponentProps<any>> {
  state = {
    key: '',
    organization: undefined,
    organization_id: -1,
    sortFacilities: 'a-z',
    showAcknowledgmentModal: false,
    showProviderDetailModal: false,
    submittingAcknowledge: false,
  }

  componentDidMount() {
    const { carePlanToSign, providerDetailToUpdate, location } = this.props
    const isLocationApplicationDashboard = location.pathname.startsWith('/provider/locationapplication');
    if (!isLocationApplicationDashboard) {
      if (carePlanToSign.length > 0) {
        this.setState({ showAcknowledgmentModal: true });
      }
      if (providerDetailToUpdate.length > 0) {
        this.setState({ showProviderDetailModal: true });
      }
    }
  }

  componentDidUpdate(prevProps: Props & RouteComponentProps<any>) {
    const { carePlanToSign, providerDetailToUpdate, location } = this.props;
    const isLocationApplicationDashboard = location.pathname.startsWith('/provider/locationapplication');

    if (!isLocationApplicationDashboard) {
      if (carePlanToSign !== prevProps.carePlanToSign) {
        if (carePlanToSign.length > 0) {
          this.setState({ showAcknowledgmentModal: true });
        }
      }

      if (providerDetailToUpdate !== prevProps.providerDetailToUpdate) {
        if (providerDetailToUpdate.length > 0) {
          this.setState({ showProviderDetailModal: true });
        }
      }
    }
  }

  closeModal = () => {
    const { selectedOrganization, showOrganizationModal } = this.props

    if (selectedOrganization.organization_id !== -1) {
      this.setState({
        organization: undefined,
        organization_id: -1
      })
      showOrganizationModal(false)
    }
  }

  handleOnChangeOrganization = (selected: any) => {
    this.setState({ organization: selected, organization_id: selected ? parseInt(selected.value) : null })
  }

  handleUpdateSelectedOrganization = () => {
    const { selectedOrganization, user, getCarePlanToSign, getCarePlanGrid, getDetailToUpdate, setProviderList, setSelectedOrganization, showOrganizationModal } = this.props
    const { organization_id } = this.state
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

    if (user.organization_data !== undefined) {
      let organization = user.organization_data.find((organizationList) => organizationList.organization_id === organization_id)
      const email = JSON.parse(localStorage.getItem('p_sid') || '{}')

      if (organization !== undefined && organization.organization_id !== selectedOrganization.organization_id) {
        getCarePlanToSign(organization.organization_id, email.eid, token)
        getCarePlanGrid(organization.organization_id, email.eid, token)
        getDetailToUpdate(organization.organization_id, email.eid, token)
        setSelectedOrganization(organization)
        setProviderList([])
      }
    }

    showOrganizationModal(false)
    this.setState({
      organization: undefined,
      organization_id: -1
    })
  }

  handleLogout = () => {
    const { history, user, addUserActivity, unauthUser } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

    unauthUser()
    history.push('/login')

    addUserActivity({
      eid: email.eid,
      activity: 'Logout'
    }, token)
  }

  handleSubmitAcknowledge = () => {
    const { selectedOrganization, updateProviderAcknowledge } = this.props
    const email = JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    const data = {
      eid: email.eid,
      organizationId: selectedOrganization.organization_id
    }

    updateProviderAcknowledge(data, token)
    this.setState({ submittingAcknowledge: true })
  }

  render() {
    const navbarItems = (
      location: string,
      handleLogout: (event: any) => void,
      role_id: number
    ) => {
      let adminMenu

      if (role_id === 5) {
        adminMenu = (
          <Dropdown.Item eventKey="3" value="Admin">
            <Link className="megamenuDropdownItem headerLink" to="/user/all">
              User List
            </Link>
            <Link className="megamenuDropdownItem headerLink" to="/user/add">
              Add a User
            </Link>
          </Dropdown.Item>
        )
      }
      const headerNavbar = getBannerColor()

      if (location.indexOf('/login') === -1)
        return (
          <Navbar variant="dark" className={headerNavbar} id="header">
            <Navbar variant="dark" className={headerNavbar} id="header">
              <Navbar.Brand className='logo-divider'><img className='logo' src={LogoImage} alt="lakeland-logo" /></Navbar.Brand>
              <Can I='View' a='ProviderPortal'>
                <span className='logo-title'>PROVIDERS</span>
              </Can>
            </Navbar>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ml-auto">
                <Can I='View' a='ProviderPortal'>
                  <Link className="header-link" to='/profile'>Profile</Link>
                  <Link className="header-link" to='/newsupdates'>News & Updates</Link>
                  <Link className="header-link" to='/resources'>Resources</Link>
                  <Link className="header-link" to='/contact'>Contact</Link>
                  <Dropdown className="headerDropdown">
                    <Dropdown.Toggle className="headerDropdownButton" id="dropdown-custom-components-account" >
                      Account
                    </Dropdown.Toggle>
                    <Dropdown.Menu alignRight as={MegaMenu}>
                      {adminMenu}
                      <Dropdown.Item eventKey="1" value="My Account">
                        <Link className="megamenuDropdownItem" to="/user">
                          My Profile
                        </Link>
                        <Dropdown.Item className="megamenuDropdownItem headerLink" eventKey="2" onClick={handleLogout}>
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Can>
                <Can I='View' not a='ProviderPortal'>
                  <Link className="header-link" to="/login" onClick={handleLogout}>Log Out</Link>
                </Can>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        )
      else
        return (
          <Navbar variant="dark" className={headerNavbar} id="header">
            <Navbar.Brand className='logo-divider'><img className='logo' src={LogoImage} alt="lakeland-logo" /></Navbar.Brand>
            <span className='logo-title'>PROVIDERS</span>
          </Navbar>
        )
    }
    const { updateProviderAcknowledgeState, user, organizationModal } = this.props
    const { organization, organization_id, showAcknowledgmentModal, showProviderDetailModal, submittingAcknowledge } = this.state

    let role_id = 1
    if (user !== undefined)
      role_id = user.role_id

    return (
      <div>
        {navbarItems(this.props.location.pathname, this.handleLogout, role_id)}
        <SwitchOrganizationModal
          disableButton={organization_id === -1}
          organizationOptions={generateOrganizationList(user.organization_data !== undefined ? sortArrayOfObjects(user.organization_data, 'organization_name') : [])}
          selectedOrganization={organization}
          show={organizationModal}
          onClose={this.closeModal}
          onChangeOrganization={this.handleOnChangeOrganization}
          onClickSelect={this.handleUpdateSelectedOrganization}
        />
        <AcknowledgmentModal
          show={showAcknowledgmentModal}
          state={updateProviderAcknowledgeState}
          submittingAcknowledge={submittingAcknowledge}
          onClose={() => this.setState({ showAcknowledgmentModal: false, submittingAcknowledge: false })}
          onSubmit={this.handleSubmitAcknowledge}
        />
        <ProviderDetailModal
          show={showProviderDetailModal}
          onClose={() => this.setState({ showProviderDetailModal: false })}
        />
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  carePlanToSign: state.carePlan.carePlanToSign.data,
  user: state.authentication.user.data,
  organizationModal: state.authentication.organizationModal,
  providerDetailToUpdate: state.providerDetail.providerDetailToUpdate.data,
  selectedOrganization: state.authentication.selectedOrganization,
  updateProviderAcknowledgeState: state.carePlan.updateProviderAcknowledge,
})

const mapDispatchToProps = (dispatch: any) => ({
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string) => dispatch(addUserActivity(data, token)),
  getCarePlanToSign: (organizationId: number, eid: string, token: string) => dispatch(getCarePlanToSign(organizationId, eid, token)),
  getCarePlanGrid: (organizationId: number, eid: string, token: string) => dispatch(getCarePlanGrid(organizationId, eid, token)),
  getDetailToUpdate: (id: number, eid: string, token: string) => dispatch(getDetailToUpdate(id, eid, token)),
  setProviderList: (providerList: Array<Provider>) => dispatch(setProviderList(providerList)),
  setSelectedOrganization: (organization: Organization) => dispatch(setSelectedOrganization(organization)),
  showOrganizationModal: (organizationModal: boolean) => dispatch(showOrganizationModal(organizationModal)),
  unauthUser: () => dispatch(unauthUser()),
  updateProviderAcknowledge: (data: any, token: string) => dispatch(updateProviderAcknowledge(data, token))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Header)
)